/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrdataplaceholder2Inputs */

const en_qrdataplaceholder2 = /** @type {(inputs: Qrdataplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://pulsify.app/e/your-event`)
};

const de_qrdataplaceholder2 = /** @type {(inputs: Qrdataplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://pulsify.app/e/dein-event`)
};

/**
* | output |
* | --- |
* | "https://pulsify.app/e/your-event" |
*
* @param {Qrdataplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrdataplaceholder2 = /** @type {((inputs?: Qrdataplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrdataplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrdataplaceholder2(inputs)
	return de_qrdataplaceholder2(inputs)
});
export { qrdataplaceholder2 as "qrDataPlaceholder" }